"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Address = /** @class */function (_super) {
  __extends(Address, _super);
  function Address() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.autocompleteService = null;
    _this.placeService = null;
    _this.state = {
      addressPlaceholder: "",
      error: ""
    };
    _this.setAsyncState = function (newState) {
      return new Promise(function (resolve) {
        return _this.setState(newState, resolve);
      });
    };
    _this.handleSubmit = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var testCond, error, textFilter;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              testCond = false;
              error = "Please input an address";
              if (!this.props.optional) {
                textFilter = /^[^\s]+(\s+[^\s]+)*\s?$/;
                testCond = textFilter.test(this.props.value.name);
                /* eslint-enable */
              } else {
                testCond = true;
              }
              if (!!testCond) return [3 /*break*/, 2];
              return [4 /*yield*/, this.setAsyncState({
                error: error
              })];
            case 1:
              _a.sent();
              return [3 /*break*/, 4];
            case 2:
              return [4 /*yield*/, this.setAsyncState({
                error: ""
              })];
            case 3:
              _a.sent();
              _a.label = 4;
            case 4:
              return [2 /*return*/, testCond];
          }
        });
      });
    };
    _this.handlePlaceChangeListener = function () {
      var selectedPlace = _this.autocompleteService.getPlace();
      var initialAddress = {
        name: "",
        lat: 0,
        lng: 0,
        district: "",
        state: "",
        country: ""
      };
      if (selectedPlace.address_components) {
        selectedPlace.address_components.map(function (eachAddress) {
          var _a, _b, _c;
          if (eachAddress.types.includes("country")) {
            initialAddress["country"] = (_a = eachAddress.long_name) !== null && _a !== void 0 ? _a : "";
          } else if (eachAddress.types.includes("administrative_area_level_1")) {
            initialAddress["state"] = (_b = eachAddress.long_name) !== null && _b !== void 0 ? _b : "";
          } else if (eachAddress.types.includes("locality")) {
            initialAddress["district"] = (_c = eachAddress.long_name) !== null && _c !== void 0 ? _c : "";
          }
          return "";
        });
      }
      initialAddress["name"] = selectedPlace.formatted_address;
      initialAddress["lat"] = selectedPlace.geometry.location.lat();
      initialAddress["lng"] = selectedPlace.geometry.location.lng();
      _this.setState({
        addressPlaceholder: ""
      });
      if (_this.props.onChange) {
        _this.props.onChange(initialAddress);
      }
    };
    _this.handleOnChange = function (e) {
      _this.setState({
        addressPlaceholder: e.target.value
      });
      if (_this.props.onChange) {
        _this.props.onChange({
          name: e.target.value,
          lat: 0,
          lng: 0
        });
      }
    };
    _this.handleFocus = function () {
      _this.setState({
        addressPlaceholder: ""
      });
      if (_this.props.onChange) {
        _this.props.onChange({
          name: "",
          lat: 0,
          lng: 0
        });
      }
    };
    return _this;
  }
  Address.prototype.componentDidMount = function () {
    if (window.google && this.props.id) {
      var input = document.getElementById(this.props.id);
      this.autocompleteService = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: {
          country: "my"
        },
        fields: ["geometry", "formatted_address", "address_component"]
      });
      this.autocompleteService.addListener("place_changed", this.handlePlaceChangeListener);
    }
  };
  Address.prototype.render = function () {
    var _a;
    var defaultClassName = "block w-full border border-gray-300 rounded-md mt-1 px-5 py-3 text-base text-gray-900 placeholder-gray-300 focus:border-primary-500 focus:outline-none";
    if (this.state.error) {
      defaultClassName += " mb-0.5 border-red-300";
    }
    if (this.props.className) {
      defaultClassName += " ".concat(this.props.className);
    }
    var containerClassName = "relative ";
    if (this.props.containerClassName) {
      containerClassName += this.props.containerClassName;
    }
    return react_1.default.createElement("div", {
      className: containerClassName
    }, react_1.default.createElement("div", {
      className: "flex justify-between"
    }, react_1.default.createElement("label", {
      className: "block text-sm font-medium text-gray-700"
    }, this.props.label), react_1.default.createElement("span", {
      className: "text-sm text-gray-500",
      id: "email-optional"
    }, "Lat : ", this.props.value.lat.toFixed(4), " Lng :", " ", this.props.value.lng.toFixed(4))), react_1.default.createElement("label", {
      className: "sr-only"
    }, this.props.label), react_1.default.createElement("input", {
      id: this.props.id,
      className: defaultClassName,
      value: this.state.addressPlaceholder ? this.state.addressPlaceholder : this.props.value.name,
      disabled: this.props.disabled,
      placeholder: (_a = this.props.placeholder) !== null && _a !== void 0 ? _a : "Enter your address",
      onFocus: this.handleFocus,
      onChange: this.handleOnChange
    }), react_1.default.createElement("span", {
      className: "text-red-500 text-sm"
    }, this.state.error));
  };
  return Address;
}(react_1.Component);
exports.Address = Address;